import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { TextField } from '@material-ui/core';
import { size } from 'lodash/fp';

const S = {
  TextField: styled(TextField)`
    .MuiFormLabel-root {
      color: ${({ theme }) => theme.palette.grey[500]};
    }
    .MuiFormLabel-root.Mui-error {
      color: #e91e63;
    }
    .MuiFormLabel-root.Mui-focused {
      color: ${({ theme }) => theme.palette.secondary.main};
    }
    .MuiInput-underline::after {
      border-bottom-color: ${({ theme }) => theme.palette.secondary.main};
    }
    ${({ error }) => error && css`
      .MuiFormLabel-root.Mui-focused {
        color: #e91e63;
      }
      .MuiInput-underline::after {
        border-bottom-color: #e91e63;
      }
      .MuiFormHelperText-root {
        color: #e91e63;
        font-size: 0.75rem;
        line-height: 1.33;
      }
    `}
  `,
};

const PhoneNumberField = ({ field: { onChange, ...field }, form, ...otherProps }) => {
  const error = useMemo(() => !!(
    form.errors[field.name] && form.touched[field.name]
  ), [field.name, form.errors, form.touched]);

  const handleChange = useCallback((event) => {
    if ((/^\d+$/.test(event.target.value) || event.target.value === '') && size(event.target.value) <= 4) {
      form.setFieldValue(field.name, event.target.value);
    }
  }, [field.name, form]);

  return (
    <S.TextField
      {...field}
      id="phoneNumber"
      type="number"
      label="휴대폰 뒷번호 4자리"
      color="secondary"
      margin="normal"
      helperText={error && '숫자 4자리를 입력해주세요.'}
      error={error}
      autoFocus
      fullWidth
      {...otherProps}
      onChange={handleChange}
    />
  );
};

PhoneNumberField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]).isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.shape({}).isRequired,
    touched: PropTypes.shape({}).isRequired,
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
};

export default PhoneNumberField;
